import { render, staticRenderFns } from "./StudyTasksSelectionComponent.vue?vue&type=template&id=3254faa6&scoped=true&"
import script from "./StudyTasksSelectionComponent.vue?vue&type=script&lang=js&"
export * from "./StudyTasksSelectionComponent.vue?vue&type=script&lang=js&"
import style0 from "./StudyTasksSelectionComponent.vue?vue&type=style&index=0&id=3254faa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3254faa6",
  null
  
)

export default component.exports